// extracted by mini-css-extract-plugin
export default {"roleOption":"styles_roleOption__FGYFo","activeRoleOption":"styles_activeRoleOption__A476I"};